import React from 'react';
import { connect } from 'react-redux';
import { Translation } from 'react-i18next';
import { education as educationCopy } from '../../copy/onboardingCopy.json';
import universalLearner from '../../ASUPhotos/icons/me3_UniversalLearner_Image.png';
import { TopDashboardComponent } from './utility/TopDashboardComponent';
import { Benefits } from './utility/Benefits';
import admission from '../../ASUPhotos/icons/me3_Icon_EarnAdmission.svg';
import pay from '../../ASUPhotos/icons/me3_Icon_PayAfterYouPass.svg';
import diploma from '../../ASUPhotos/icons/me3_Diploma.svg';

export class UniversalLearner extends React.Component {
  primaryColor = {
    color: this.props.tenant.primary,
  };

  render() {
    return (
      <Translation>
        {(t) => (
          <>
            <div id="universal-learner" className="universal-learner">
              <div className="top-dashboard">
                <TopDashboardComponent
                  tenant={this.props.tenant}
                  headerText="Universal Learner Courses"
                  headerStyle="universal-learner-header"
                  appendText="universal-learner"
                  cornerImage={universalLearner}
                  altText={t('A person wearing a yellow shirt')}
                  copyDescription={
                    this.props.onboarding.userData.user.educationLevel ===
                      educationCopy.degree2 ||
                    this.props.onboarding.userData.user.educationLevel ===
                      educationCopy.degree3
                      ? t(
                          '{{coursesName}} are a selection of first-year college courses offered online at ASU and open to everyone. Through {{courses}}, you can test the college waters, earn college credit for a fraction of the cost and pay only if you pass.',
                          {
                            coursesName: '', // coursesName is empty because 'headerText' provides the sentence subject
                            courses: 'Universal Learner Courses',
                          }
                        )
                      : t(
                          '{{coursesName}} are a selection of first-year college courses offered online at ASU and open to everyone. Through {{courses}}, you can gain college credit for a fraction of the cost, pay only if you pass, and earn admission into the university.',
                          {
                            coursesName: '', // coursesName is empty because 'headerText' provides the sentence subject
                            courses: 'Universal Learner Courses',
                          }
                        )
                  }
                  copyWebsiteLink={t('Visit the {{websiteTitle}} website', {
                    websiteTitle: 'Universal Learner Courses',
                  })}
                  websiteLink="https://ea.asu.edu/"
                  primaryColor={this.primaryColor}
                />
              </div>
              <Benefits
                tenant={this.props.tenant}
                appendText="universal-learner"
                title={t('Benefits of {{courses}}', {
                  courses: 'Universal Learner Courses',
                })}
                benefitOneJsx={
                  /* eslint-disable-next-line react/jsx-wrap-multilines */
                  <span>
                    {t(
                      `Pay for a course only if you successfully pass with a 'C' or higher. Total course cost is $425.`
                    )}
                  </span>
                }
                benefitTwo={
                  this.props.onboarding.userData.user.educationLevel ===
                    educationCopy.degree2 ||
                  this.props.onboarding.userData.user.educationLevel ===
                    educationCopy.degree3
                    ? t(
                        'Courses are taught by ASU faculty. Use credit at ASU or transfer the credit to another university.'
                      )
                    : t(
                        'Courses are taught by ASU faculty. Use credit at ASU or at another university.'
                      )
                }
                benefitThree={
                  this.props.onboarding.userData.user.educationLevel ===
                    educationCopy.degree2 ||
                  this.props.onboarding.userData.user.educationLevel ===
                    educationCopy.degree3
                    ? t(
                        'Choose from 30+ courses that count towards a wide variety of degrees.'
                      )
                    : t(
                        'Complete the required number of credit hours with a 2.75 GPA to earn admission into Arizona State University'
                      )
                }
                benefitTitleOne={t('Pay after you pass')}
                benefitTitleTwo={t('Earn college credit')}
                benefitTitleThree={
                  this.props.onboarding.userData.user.educationLevel ===
                    educationCopy.degree2 ||
                  this.props.onboarding.userData.user.educationLevel ===
                    educationCopy.degree3
                    ? t('Make direct progress towards an undergraduate degree')
                    : t('Earn admission into Arizona State University')
                }
                imageOne={pay}
                imageTwo={diploma}
                imageThree={admission}
              />
            </div>
          </>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => {
  const onboarding = state.onboarding;
  return { onboarding };
};

export default connect(mapStateToProps)(UniversalLearner);
